var _g, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _rect9, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgerNewUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 234,
    viewBox: "0 0 235 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_936_5930_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.097781 0.234674 -0.234674 -0.097781 117.5 117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    fill: "url(#paint0_diamond_936_5930)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_936_5930)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_936_5930)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 605.588,
    height: 605.588,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_936_5930)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 117,
    r: 117,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"stopsVar\":[{\"color\":{\"r\":0.062745101749897003,\"g\":0.63921570777893066,\"b\":0.49803921580314636,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.64999997615814209},{\"color\":{\"r\":0.90980392694473267,\"g\":0.91372549533843994,\"b\":0.92941176891326904,\"a\":1.0},\"position\":0.65206468105316162}],\"transform\":{\"m00\":-195.56198120117188,\"m01\":-469.34872436523438,\"m02\":449.95535278320312,\"m10\":469.34872436523438,\"m11\":-195.56198120117188,\"m12\":-19.893369674682617},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 41,
    width: 199,
    height: 153,
    rx: 5.86743,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 104,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 142,
    width: 62,
    height: 19,
    rx: 4,
    fill: "#10A37F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 104,
    width: 31.5375,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 66,
    width: 92.4121,
    height: 8.98451,
    rx: 4.49226,
    fill: "#16C098",
    fillOpacity: 0.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 178,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#10A37F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 178,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6AFBF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 178,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#B6AFBF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 92.5,
    x2: 198.5,
    y2: 92.5,
    stroke: "#D9D9D9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 124.5,
    x2: 198.5,
    y2: 124.5,
    stroke: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 21,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#E8E9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.27 48C109.696 48 110.04 47.664 110.04 47.2258V41.5711C110.294 41.459 111.247 41.0921 112.736 41.0921C116.486 41.0921 118.838 42.9365 122.405 42.9365C123.986 42.9365 124.574 42.7631 125.345 42.4166C126.044 42.101 126.5 41.5711 126.5 40.6339V30.2822C126.5 29.7423 126.033 29.4163 125.446 29.4163C124.949 29.4163 124.017 29.8545 122.273 29.8545C118.706 29.8545 116.365 28 112.604 28C111.023 28 110.426 28.173 109.655 28.5195C108.956 28.8355 108.5 29.3758 108.5 30.3026V47.2258C108.5 47.6431 108.855 47.9996 109.27 47.9996M122.405 41.3872C119.03 41.3872 116.638 39.5532 112.736 39.5532C111.621 39.5532 110.618 39.6858 110.04 39.9201V30.3435C110.182 30.0175 111.023 29.5489 112.604 29.5489C116.172 29.5489 118.554 31.3929 122.273 31.3929C123.378 31.3929 124.29 31.2603 124.969 31.0564V40.593C124.827 40.9191 123.986 41.3877 122.404 41.3877",
    fill: "#10A37F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_936_5930_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 117,
    r: 117
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_936_5930",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E8E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652065,
    stopColor: "#E8E9ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgerNewUserIcon);
export default __webpack_public_path__ + "static/media/BudgerNewUserIcon.59a9fe52e3609e0fa22623310862634c.svg";
export { ForwardRef as ReactComponent };